import { render, staticRenderFns } from "./SubKenoResultApp.vue?vue&type=template&id=36ac421c&scoped=true&"
import script from "./SubKenoResultApp.vue?vue&type=script&lang=js&"
export * from "./SubKenoResultApp.vue?vue&type=script&lang=js&"
import style0 from "./SubKenoResultApp.vue?vue&type=style&index=0&id=36ac421c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac421c",
  null
  
)

export default component.exports